import { modelsCompFn } from '@/lib/filter/base-frontend-filter/scope';

// We need to handle filters for static direct options (based on constants)
const handleStaticOptions = (models) => {
  const valueMapper = (el) => (typeof el === 'string' ? { uid: el } : el);

  if (Array.isArray(models)) {
    return models.map((m) => valueMapper(m));
  }
  return valueMapper(models);
};

// We need to handle the filters for static direct options (based on static PO shape { value: string })
const handleStaticNeededOptions = (neededModels) => {
  const valueMapper = (el) => (el.value !== undefined && el.uid === undefined ? { uid: el.value } : el);
  return neededModels.map((m) => valueMapper(m));
};

export const optionsFn = ({ propertyValues, scope }) => {
  const models = propertyValues.find((pv) => pv.property.uid === scope.property.uid)?.selectedOptions;
  const neededModels = scope.selectedOptions;
  return modelsCompFn({ models, neededModels, isEmpty: scope.isEmpty });
};

export const directOptionsFn = ({ entity, scope }) => {
  const models = entity[scope.directProperty.edgeName];
  const neededModels = scope.selectedOptions;
  return modelsCompFn({ models: handleStaticOptions(models), neededModels: handleStaticNeededOptions(neededModels), isEmpty: scope.isEmpty });
};
